export const USERNAME_ROLES = ['call_center_operator', 'call_center_manager'];
